import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./video-highlight.module.css";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import CallMadeIcon from "@mui/icons-material/CallMade";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import {
  setShowSelectionToolkit,
  setShowToolkit,
  setShowToolkitSecond,
  setToolkitUrl,
} from "../../../Redux/Actions/VideoHighlightAction";
import { FaTrashAlt } from "react-icons/fa";
import SearchIcon from "@mui/icons-material/Search";
import EggSharpIcon from "@mui/icons-material/EggSharp";
function SelectionToolkit() {
  const { toolkitUrl } = useSelector((state) => state?.videoHighlightData);
  const dispatch = useDispatch();

  const handleAddToolkit = (toolkitImage) => {
    if (toolkitUrl.length <= 1) {
      setToolkitUrl(dispatch, [...toolkitUrl, toolkitImage]);
      setShowToolkit(dispatch, true);
      setShowToolkitSecond(dispatch, toolkitUrl.length === 1);
    }
  };

  const handleDeleteToolkit = () => {
    setToolkitUrl(dispatch, []);
    setShowSelectionToolkit(dispatch, false);
    setShowToolkit(dispatch, false);
    setShowToolkitSecond(dispatch, false);
  };
  return (
    <div className={`${styles.selectionToolkitIconWrapper}`}>
      <img
        alt="toolkit1"
        src="/toolkit/toolkit1.png"
        className={`${styles.iconHoverEffect} ${styles.toolkitIconOne}`}
        onClick={() => handleAddToolkit("/toolkit/toolkit1.png")}
      />
      <StarBorderIcon
        className={`${styles.iconHoverEffect} ${styles.toolkitIconTwo}`}
        onClick={() => handleAddToolkit("/toolkit/toolkit2.png")}
      />
      <CircleOutlinedIcon
        className={`${styles.iconHoverEffect} ${styles.toolkitIconTwo}`}
        onClick={() => handleAddToolkit("/toolkit/toolkit3.png")}
      />
      <CallMadeIcon
        className={`${styles.iconHoverEffect} ${styles.toolkitIconTwo}`}
        onClick={() => handleAddToolkit("/toolkit/toolkit4.png")}
      />
      <ZoomInMapIcon
        className={`${styles.iconHoverEffect} ${styles.toolkitIconTwo}`}
        onClick={() => handleAddToolkit("/toolkit/toolkit5.png")}
      />
      <EggSharpIcon
        className={`${styles.iconHoverEffect} ${styles.toolkitIconTwo}`}
        onClick={() => handleAddToolkit("/toolkit/toolkit6.png")}
      />
      <SearchIcon
        className={`${styles.iconHoverEffect} ${styles.toolkitIconTwo}`}
        onClick={() => handleAddToolkit("/toolkit/toolkit7.png")}
      />
      <FaTrashAlt
        className={`${styles.iconHoverEffect} ${styles.toolkitDelete}`}
        onClick={handleDeleteToolkit}
      />
    </div>
  );
}

export default SelectionToolkit;
